import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "flex text-sm font-semibold pb-1" }, " Cambiar estado de solicitud ", -1)
const _hoisted_4 = { class: "flex flex-col w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "flex text-sm font-semibold pb-1" }, " Enviar notificación via emails ", -1)
const _hoisted_6 = { class: "flex flex-row gap-6 m-[2%]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "sendEmailFlag" }, "Enviar notificación", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Selector = _resolveComponent("Selector")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: 'Detalle del dividendo ' + _ctx.dividend?.bankName,
    visible: _ctx.visible,
    "onUpdate:visible": _ctx.closeModal,
    class: "z-10"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TextField, {
          disabled: "",
          name: "'fecha'",
          type: "imput",
          label: "Banco",
          model: _ctx.dividend?.bankName
        }, null, 8, ["model"])
      ]),
      _createVNode(_component_TextField, {
        disabled: "",
        name: "'fecha'",
        type: "imput",
        label: "Fecha de creación",
        model: _ctx.dividend?.pendingDate.toString()
      }, null, 8, ["model"]),
      _createVNode(_component_TextField, {
        disabled: "",
        name: "actionist",
        type: "imput",
        label: "Accionista",
        model: _ctx.dividend?.accountOwnerName
      }, null, 8, ["model"]),
      _createVNode(_component_TextField, {
        disabled: "",
        name: "amount",
        type: "imput",
        label: "Monto",
        model: _ctx.dividend?.totalClp
      }, null, 8, ["model"]),
      _createVNode(_component_TextField, {
        disabled: "",
        name: "acount",
        type: "imput",
        label: "Cuenta de destino",
        model: _ctx.dividend?.accountNumber
      }, null, 8, ["model"]),
      _createVNode(_component_TextField, {
        name: "Comentario",
        type: "textarea",
        label: "Comentario",
        model: _ctx.completeData.comment,
        "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.completeData.comment) = $event))
      }, null, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("section", _hoisted_4, [
          _createVNode(_component_Selector, {
            values: [_ctx.DividendStatusType.PAID, _ctx.DividendStatusType.PENDING, _ctx.DividendStatusType.REJECTED],
            items: [_ctx.getPrettyPrintStatus(_ctx.DividendStatusType.PAID), _ctx.getPrettyPrintStatus(_ctx.DividendStatusType.PENDING), _ctx.getPrettyPrintStatus(_ctx.DividendStatusType.REJECTED)],
            model: _ctx.dividendNewStatus,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dividendNewStatus) = $event))
          }, null, 8, ["values", "items", "model"])
        ]),
        _hoisted_5,
        _createElementVNode("section", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            id: "sendEmailFlag",
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.completeData.sendEmail) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.completeData.sendEmail]
          ]),
          _hoisted_7
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("footer", null, [
        _createElementVNode("button", {
          class: "success btn mt-2",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)))
        }, "Guardar")
      ])
    ]),
    _: 1
  }, 8, ["title", "visible", "onUpdate:visible"]))
}